import AppLayout from "../../components/layout/AppLayout"
import "../../styles/settings.scss"

const HelpPage = () => {
  return (
    <AppLayout pageTitle="ヘルプ">
      <div className="settings-card">
        <div className="settings-card__header">
          <i className="bi bi-question-circle" />
          <h2>ヘルプ</h2>
        </div>
        <div className="settings-card__body">
          <ul className="help-links">
            <li>
              <a href="/instagram-setup-guide.html" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram" />
                Instagramアカウントの追加手順
              </a>
            </li>
            <li>
              <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-shield-check" />
                プライバシーポリシー
              </a>
            </li>
            <li>
              <a href="/terms.html" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-file-text" />
                利用規約
              </a>
            </li>
            <li>
              <a href="/transactions_law.html" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-file-earmark-text" />
                特定商取引法に基づく表記
              </a>
            </li>
          </ul>
        </div>
      </div>
    </AppLayout>
  )
}

export default HelpPage
